import { orderBy } from "es-toolkit";

import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import type { OrderingDirection } from "../types.ts";

export const createByUpdatedOn = (orderingDirection: OrderingDirection) => (modules: InteractModuleListItem[]) =>
  modules
    ? orderBy(
        modules,
        [({ updatedOn }) => !!updatedOn, ({ updatedOn }) => (updatedOn ? new Date(updatedOn) : undefined)],
        [orderingDirection === "ascending" ? "asc" : "desc", orderingDirection === "ascending" ? "desc" : "asc"],
      )
    : [];
